import { render } from "./MainStaffLoans.vue?vue&type=template&id=17b9c8f2&scoped=true"
import script from "./MainStaffLoans.vue?vue&type=script&lang=js"
export * from "./MainStaffLoans.vue?vue&type=script&lang=js"

import "./MainStaffLoans.vue?vue&type=style&index=0&id=17b9c8f2&scoped=true&lang=css"

import exportComponent from "D:\\facturacion electronica\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17b9c8f2"]])

export default __exports__